import { BaseService } from './BaseService';

export default class SecurityService extends BaseService {
    loadUsersRoles(userIds) {
        return this.postToAPI("/security/users/roles/batch", {
            userIds: userIds.join(',')
        });
    }

    saveUserRole(publisherId, userId, role) {
        return this.putToAPI(
            `/security/publishers/${publisherId}/users/${userId}/role`,
            { role }
        );
    }

    deleteUserRole(publisherId, userId) {
        return this.deleteFromAPI(
            `/security/publishers/${publisherId}/users/${userId}/role`
        );
    }
}
